import { IOnInit } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import { IGridSettings } from "../../../records/grids/settings/gridSettingsService";
import { IQuery, ServiceResponse } from "../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { ProcessGroup, ProcessInformation } from "../../model/ProcessGroups";
import {
  UserProfile,
  vsName as UserProfileName,
} from "../../../application/UserProfile";
import { ProcessApiResponse } from "../../model/ProcessApi";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import { processInstancesName } from "../../config/objects";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ProcessInformationService,
  vsServiceName as ProcessInformationServiceName,
} from "../../services/processInformationService";

export interface ProcessSelectedArgs {
  processViewController: ProcessViewController;
  processInformation: ProcessInformation;
}

export class ProcessViewController implements IOnInit {
  static $inject = [
    ServerUtilityName,
    UserProfileName,
    RecordGridViewServiceName,
    ColumnDefinitionServiceName,
    ProcessInformationServiceName,
  ];

  gridDataSource!: RecordDataSource;
  columns!: ColDef[];

  createProcesses: ProcessInformation[] = [];

  readonly gridSettings!: IGridSettings;
  readonly processGroup!: ProcessGroup;
  readonly defaultQuery!: IQuery;
  readonly additionalGridColumns!: ColDef[];

  constructor(
    private readonly serverUtility: ServerUtility,
    private readonly userProfile: UserProfile,
    private readonly recordGridViewService: RecordGridViewService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly processInformationService: ProcessInformationService
  ) {}

  $onInit(): void {
    this.createProcesses = this.processGroup.ProcessInformation.filter((pi) =>
      this.userProfile.hasRole(pi.CreateRole)
    );

    this.gridDataSource = new RecordDataSource(
      this.serverUtility,
      `/api${this.processGroup.Url}`
    );

    this.columns = this.getColumns();
  }

  private getColumns() {
    const gridConfiguration =
      this.recordGridViewService.getGridConfiguration(processInstancesName);
    const processColumns = gridConfiguration?.columns ?? [];

    const fieldNames = new Set<string>(processColumns.map((c) => c.field!));
    const additionalGridColumns = this.additionalGridColumns.filter(
      (c) => !fieldNames.has(c.field!)
    );

    return [
      ...processColumns,
      ...additionalGridColumns,
      this.columnDefinitionService.getNumberColDef({
        field: "ProcessInstancesId",
        header: "Process Instances Id",
        hide: true,
      }),
    ];
  }
}
